import { Button, ButtonProps } from "antd";
import { RefAttributes } from "react";

import styled from "styled-components";
import { Substitute } from "styled-components/dist/types";
import { IVariant } from "utils";

type IButtonVariant = IVariant;
export const AppButton = styled(Button)<{
  variant?: IButtonVariant;
  fullWidth?: boolean;
}>`
  //typography
  color: #fff;

  /* Bold/Title Large */
  font-family: Manrope-Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
  font-style: normal;

  height: auto;
  min-height: 44px;
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 100px;
  ${({ variant, theme: { colors } }) => {
    switch (variant) {
      case "primary":
        return `
        background: #5575F7;
        box-shadow: 0px 16px 40px -12px #5575F766;
        border: none;
        outline: none;
        color: #fff;
      `;
      case "secondary":
        return `
        background: #FFFFFF;
        border: solid 1px  #5575F7;
        outline: none;
        color: #5575F7;
      `;
      case "accent":
        return `
        background: #FFFFFF;
        border: 1px solid #5575F7;
        outline: none;
        color: #5575F7;
      `;
      case "delete":
        return `
        background: #CC0A3E;
        border: solid 1px  #CC0A3E;
        outline: none;
        color: #FFFFFF;
      `;
      case "text": {
        return `
          background: transparent;
          border: none;
          outline: none;
          color: #5575F7;
          font-family: Manrope-Regular;
        `
      }
      default:
        return "";
    }
  }}
  ${({ fullWidth }) => fullWidth && "width: 100%"}
`;
export type AppButtonProps = Substitute<ButtonProps & RefAttributes<HTMLAnchorElement | HTMLButtonElement>, {
    variant?: "primary" | "secondary" | "info" | "danger" | "info-gray" | "text";
    fullWidth?: boolean;
}>